var map = {
	"./chunithm_luminous.json": [
		1566,
		160
	],
	"./chunithm_new.json": [
		8031,
		484
	],
	"./chunithm_paradise_lost.json": [
		6587,
		591
	],
	"./chunithm_sun.json": [
		3634,
		942
	],
	"./maimai_dx_buddies_plus.json": [
		3795,
		796
	],
	"./maimai_dx_festival.json": [
		653,
		696
	],
	"./maimai_dx_festival_plus.json": [
		510,
		695
	],
	"./maimai_dx_prism.json": [
		7877,
		187
	],
	"./maimai_dx_universe.json": [
		4180,
		369
	],
	"./wacca_reverse.json": [
		2926,
		94
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2616;
module.exports = webpackAsyncContext;